import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.172 1.097a.5.5 0 0 0-.344 0l-6.45 2.362L8 6.063l6.622-2.6zM1 12.053a.5.5 0 0 0 .328.469L7.5 14.784V6.938L1 4.384zm7.5 2.731 6.172-2.262a.5.5 0 0 0 .328-.469V4.384L8.5 6.938v7.846M7.484.156a1.5 1.5 0 0 1 1.032 0l6.5 2.385A1.5 1.5 0 0 1 16 3.95v8.103c0 .628-.394 1.19-.984 1.41l-6.5 2.38a1.5 1.5 0 0 1-1.032 0l-6.5-2.384A1.5 1.5 0 0 1 0 12.053V3.95c0-.628.394-1.19.984-1.41z"
    }, null, -1)
  ])))
}
export default { render: render }